import { css } from '@emotion/css';

export const pageCx = css`
  display: flex;
  flex-direction: column;
`;

export const mainCx = css`
  &.with-header {
    margin-top: var(--header-height);
  }

  display: flex;
  flex-direction: column;
  position: relative;

  height: 100%;
  flex: 1;
`;

export const titleBar = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
  color: #ffffff;
  margin: 0;
`;

export const backButtonCx = css`
  margin-right: 16px;
  width: 15px;
  height: 100%;
  cursor: pointer;
`;

export const toolbar = css`
  width: 100%;
  background-image: linear-gradient(to right, #00acf0 8%, #13637b);
  display: flex;
  align-items: center;
  padding: 16px;
`;
